<template>
  <b-modal
    id="modal-call"
    ref="modal-call"
    class="mc-modal"
    :title="$t('global.action.callDriver')"
    header-bg-variant="primary"
    header-close-variant="light"
    :ok-title="$t('global.action.register')"
    :cancel-title="$t('global.action.close')"
    cancel-variant="outline-primary"
    size="md"
    centered
    @hidden="resetModal"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row align-h="center">
        <b-col>
          <b-form-group
            id="noHP_label"
            :label="$t('liveView.text.insertNumber.enterPhoneNumber')"
            label-for="noHP"
            :invalid-feedback="$t('liveView.text.insertNumber.mustFill')"
            :state="statePhoneNumber"
          >
            <b-input-group prepend="+62">
              <b-form-input
                id="noHP"
                v-model="phoneNumber"
                trim
                :placeholder="`${$t('global.action.enterNumber')}...`"
                :state="statePhoneNumber"
                required
                type="number"
                @keypress="isNumber($event)"
                @paste="isPasteNumber($event)"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import { REGISTER_CALL_NUMBER } from '@/services/api/fleet'
import Swal from 'sweetalert2'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [Helper, MixPanel],
  data() {
    return {
      phoneNumber: null,
      statePhoneNumber: null,
    }
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.statePhoneNumber = valid
      return valid
    },
    resetModal() {
      this.phoneNumber = null
      this.statePhoneNumber = null
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      const input = {
        imei: this.$store.state.map.infoWindow.detail.vehicle.imei,
        phoneNumber: this.phoneNumber,
      }

      this.$apollo
        .mutate({
          mutation: REGISTER_CALL_NUMBER,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.registerCallNumber.isSuccessful) {
            this.track('Run Register Number')
            this.$bvModal.hide('modal-call')
            Swal.fire({
              title: '<strong>Pendaftaran berhasil</strong>',
              html: `Nomor <strong class="text-primary">${this.phoneNumber}</strong> dapat menghubungi pengemudi hingga pukul <strong class="text-primary">00:00</strong>`,
              imageUrl: require('@/assets/images/success-icon.png'),
              width: 400,
              showCancelButton: false,
              confirmButtonText: 'Tutup',
            })
          }
        })
    },
  },
}
</script>
